import {
  FormStepNode,
  emptyStepSingle,
  emptyStepGroup,
  emptyStepRecovery,
} from '../workoutBuilderTypes';

/**
 * Preset-scorciatoia dei mezzi canonici di condizionamento (BUG B).
 * Riempiono volume/gruppo nello step builder ma restano modificabili.
 * Chiave = slug del catalogo esercizi.
 */
export interface StepPreset {
  label: string;
  /** Costruisce un nodo step già valorizzato (con _localId nuovo). */
  build: () => FormStepNode;
}

const distance = (m: number): StepPreset => ({
  label: `${m}m`,
  build: () => ({ ...emptyStepSingle(), volumeMode: 'distance', volumeValue: String(m) }),
});

const rsa = (reps: number, dist: number, rec: number): StepPreset => ({
  label: `${reps}×${dist}m rec${rec}s`,
  build: () => ({
    ...emptyStepGroup(),
    repeat: String(reps),
    children: [
      {
        ...emptyStepSingle(),
        volumeMode: 'distance',
        volumeValue: String(dist),
        recovery: { ...emptyStepRecovery(), enabled: true, mode: 'time', value: String(rec) },
      },
    ],
  }),
});

export const STEP_PRESETS_BY_SLUG: Record<string, StepPreset[]> = {
  // Corsa a distanza → distanze classiche (modificabili)
  'distance-run': [distance(1000), distance(1500), distance(2000), distance(3000), distance(5000)],
  // RSA → schemi ripetute × distanza × recupero
  rsa: [rsa(10, 20, 20), rsa(6, 30, 20), rsa(8, 40, 25)],
};
